import store from "@/redux/store";

const generateExportKey = () => Array.from({ length: 25 }, () => Math.random().toString(36)[2] || "0").join("");

export const enqueueExcelExport = ({ url, name, params, api }) => {
	store.dispatch({
		type: "FETCHING_ADD_DOWNLOAD",
		payload: {
			file: {
				key: generateExportKey(),
				params,
				show: true,
				url,
				name,
				type: "excel",
				api,
				inExecution: false,
				inProgress: false,
				inChecked: false,
			},
		},
	});
};
